import { ActionIcon, Anchor, Group } from '@mantine/core';
import axios from 'axios';
import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { availableLanguages, baseApi } from '../../components/api';
// import '../../css/MyFooter.css';
import { IconBrandApple, IconBrandFacebook, IconBrandGooglePlay, IconBrandInstagram } from '@tabler/icons-react';
import useLanguageNavigator from '../../hooks/useLanguageNavigator';

	// const lang = language === "en" ? "" : `/${language}`
type Language = typeof availableLanguages[number];
const footerTexts: Record<Language, {poweredTitle: string; contactTitle: string; termsTitle: string; aboutTitle: string;}> = {
	en: {
		poweredTitle: "Powered by",
		contactTitle: "Contact us",
		termsTitle: "Terms and Conditions",
		aboutTitle: "About us",
	},
	ar: {
		poweredTitle: "تم التطوير بواسطة",
		contactTitle: "اتصل بنا",
		termsTitle: "الشروط والأحكام",
		aboutTitle: "من نحن",
	},
};
const MyFooter = () => {
	const { lang }: { lang: 'en' | 'ar' } = useLanguageNavigator(availableLanguages)
	const [phones, setPhones] = useState<string>("")
	const [social, setSocial] = useState<string[]>(["","","",""])
	// const phone:string= useSelector(state => state.sys.phone);
	const texts = footerTexts[lang] || footerTexts.en
	const gold = "#BC9249";
  	const white = "#FFFFFF";
	useEffect(() => {
		(async () => {
			try {
				const res = await axios.get(`${baseApi}/web/getPhones`);
				if (res.status === 200) { 
					setPhones(res.data.data.phone)
					setSocial(res.data.data.social)
				}
			} catch (err: any) {console.error("Failed to load phones:", err)} 
		})();
	}, []);
	// Detect RTL for styling
	const isRTL = lang === "ar";
	return (
		<footer dir={isRTL ? "rtl" : "ltr"}>
			<div
				style={{
					backgroundColor: "black", border: "1px solid #000000", padding: "2px",// height: "60px",
					display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center",
					direction: isRTL ? "rtl" : "ltr",
				}}
			>
				{/* Line 2 - Contact us */}
				<div style={{ fontFamily: isRTL ? "Cairo, sans-serif" : "Montserrat, sans-serif", color: white, padding: "0px", margin:'0', fontSize: "12px", gap: "1px", }}>
					<div style={{ display:'flex', flexDirection:'row' }}>
						{texts.contactTitle}:{"  "}
						<div style={{ color:"#BC9249" }}>&nbsp;&nbsp;{phones}</div>
					</div>
					{/* Line 3 - Terms and Conditions */}
					<div>
						<Anchor component={Link} fz={12} fw={300} m={0} p={0} to={lang === "ar" ? "/ar/terms" : "/terms"} c={white} style={{ textDecoration: "none" }}>
							{texts.termsTitle}
						</Anchor>
					</div>
					{/* Line 4 - About us */}
					<div>
						<Anchor component={Link} fz={12} fw={300} m={0} p={0} to={lang === "ar" ? "/ar/about" : "/about"} c={white} style={{ textDecoration: "none" }}>
							{texts.aboutTitle}
						</Anchor>
					</div>
					<Group gap={0} justify="center" wrap="nowrap">
						<ActionIcon component="a" href={social[0]} target="_blank" rel="noopener noreferrer" size="lg" color="gray" variant="subtle" aria-label="Twitter">
							<IconBrandFacebook size={18} stroke={1.5} />
						</ActionIcon>
						<ActionIcon component="a" href={social[1]} target="_blank" rel="noopener noreferrer" size="lg" color="gray" variant="subtle" aria-label="Instagram">
							<IconBrandInstagram size={18} stroke={1.5} />
						</ActionIcon>
						<ActionIcon component="a" href={social[2]} target="_blank" rel="noopener noreferrer" size="lg" color="gray" variant="subtle" aria-label="YouTube">
							<IconBrandGooglePlay size={18} stroke={1.5} />
						</ActionIcon>
						<ActionIcon component="a" href={social[3]} target="_blank" rel="noopener noreferrer" size="lg" color="gray" variant="subtle" aria-label="YouTube">
							<IconBrandApple size={18} stroke={1.5} />
						</ActionIcon>
					</Group>
					{/* Line 1 - Powered by */}
						{texts.poweredTitle}{" "}
						<Anchor href="https://www.smartsoftek.com" target="_blank" rel="noopener noreferrer" c={gold} fz={12} fw={300} m={0} p={0}>
							Smart Softek
						</Anchor>
				</div>
			</div>
    	</footer>
	);
}

export default MyFooter